<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import type { Swiper as SwiperType } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export type RegionSliderProps = {
  title: string
  regions: {
    name: string
    slug: string
    thumbnail: {
      src: string
      alt: string
    }
  }[]
}

defineProps<RegionSliderProps>()

const swiper = shallowRef<SwiperType>()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')
</script>

<template>
  <div>
    <AlPadding>
      <h3 class="mb-16 font-sans-header text-3xl font-thin uppercase text-al-primary">
        {{ title }}
      </h3>
    </AlPadding>

    <AlPadding side="none" class="container:px-40">
      <Swiper
        :modules="[Navigation, Pagination, A11y]"
        slides-per-view="auto"
        :space-between="40"
        :slides-per-group="isMobile ? 1 : 3"
        :center-insufficient-slides="true"
        :allow-touch-move="true"
        :pagination="{ clickable: true }"
        class="relative !pb-8"
        @swiper="(_swiper) => (swiper = _swiper)"
      >
        <SwiperSlide v-for="region in regions" :key="region.slug" class="!w-64">
          <AlLink
            :to="`/region/${region.slug}`"
            class="group/region relative flex h-[22rem] flex-col items-start justify-end overflow-hidden px-6 py-10 lg:h-[26rem]"
          >
            <img
              :src="region.thumbnail.src"
              :alt="region.thumbnail.alt"
              class="absolute inset-0 h-full w-full object-cover"
            />

            <span
              class="relative translate-y-10 hyphens-auto font-sans-header text-3xl uppercase text-white shadow-gray-500 transition-transform ease-out text-shadow-lg group-hover/region:translate-y-0"
            >
              {{ region.name }}
            </span>

            <AlSlideoutButton
              variant="primary"
              class="relative origin-left scale-75 opacity-0 transition-opacity group-hover/region:opacity-100"
            >
              Mehr erfahren
            </AlSlideoutButton>
          </AlLink>
        </SwiperSlide>
      </Swiper>
    </AlPadding>
  </div>
</template>
